import React from "react";

const MODES = [
  {
    key: 'proofread',
    displayName: '교정',
    icon: 'spellcheck',
    title: '교정',
    desc: '맞춤법, 띄어쓰기, 오타 등 문장 오류를 바로잡아요. '
  },
  {
    key: 'copyedit',
    displayName: '교열',
    icon: 'edit_note',
    title: '교열',
    desc: '교정 후, 문법과 문장 구조를 다듬고 표현을 수정해요.'
  }
];

const StepTypeSelect = ({ type, setType, setDone }) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      {MODES.map(opt => {
        let border = 'border-gray-200';
        let hoverBorder = 'hover:border-blue-300';
        let iconColor = 'text-gray-400';
        let titleColor = 'text-gray-700';
        let bg = 'bg-white';
        if (type === opt.key) {
          border = opt.key === 'proofread' ? 'border-blue-400' : 'border-gray-400';
          iconColor = opt.key === 'proofread' ? 'text-blue-600' : 'text-gray-500';
          titleColor = 'text-blue-700';
          bg = 'bg-gray-50';
        }
        return (
          <div
            key={opt.key}
            className={`flex flex-col items-start gap-2 p-4 rounded-xl border-2 transition-all min-w-0 ${border} ${hoverBorder} ${bg} cursor-pointer`}
            onClick={() => { setType(opt.key); setDone(true); }}
            style={{ boxShadow: type === opt.key ? '0 2px 8px 0 rgba(30,64,175,0.06)' : 'none' }}
          >
            <div className="flex flex-row items-center mb-1">
              <span className={`material-icons text-3xl card-icon ${iconColor}`}>{opt.icon}</span>
              <span className={`text-lg font-bold card-title ml-2 ${titleColor}`}>{opt.title}</span>
            </div>
            <span className="text-sm text-left text-gray-500 mb-2">{opt.desc}</span>
          </div>
        );
      })}
    </div>
  );
};

export default StepTypeSelect; 